import * as React from "react";
import { Container, Header, Icon, Message } from "semantic-ui-react";
import { SeverityLevel } from "@microsoft/applicationinsights-web";

import { trackException } from "./logging/trackException";

export class ErrorBoundary extends React.Component<any, { hasError: boolean }> {
    public static getDerivedStateFromError() {
        return { hasError: true };
    }

    constructor(props: any) {
        super(props);
        this.state = { hasError: false };
    }

    public componentDidCatch(error: Error) {
        trackException(error, SeverityLevel.Error);
    }

    public render() {
        if (this.state.hasError) {
            return (
                <Container textAlign="center" data-boundary-error="true">
                    <Header as="h1" color="red" textAlign="center" icon>
                        <Icon name="warning sign" />
                        <Header.Content>Error</Header.Content>
                    </Header>

                    <Message negative compact>
                        <Message.Header>Something went wrong</Message.Header>
                        <p>Try going back to the <a href="/">home page</a></p>
                    </Message>
                </Container>
            );
        }

        return this.props.children;
    }
}
